import React from 'react'

import CarouselImages from './carouselimages'

const TEXTS = [
  {
    src: 'Besuch_im_Irak_Gefluechtete_in_Sulaymaniyya.jpg',
    text: 'Besuch im Irak Geflüchtete in Sulaymaniyya'
  },
  {
    src: 'Besuch_im_Irak_Pater_Petzold_in_Sulaymaniyya.jpg',
    text: 'Besuch im Irak Pater Petzold in Sulaymaniyya'
  },
  {
    src: 'Mit_Herrn_Klaunick_in_der_Gedenkstaette.jpg',
    text: 'Mit Herrn Klaunick in der Gedenkstätte'
  },
  {
    src: 'Treffen_Juli_Museum_fuer_Islamische_Kunst.jpg',
    text: 'Treffen Juli Museum für Islamische Kunst'
  },
  {
    src: 'Treffen_Juli_Vortrag_ueber_Religionen_in_Berlin.jpg',
    text: 'Treffen Juli Vortrag über Religionen in Berlin'
  },
  {
    src: 'Treffen_Mai_Mauergedenkstaette.jpg',
    text: 'Treffen Mai Mauergedenkstätte'
  },
  {
    src: 'Treffen_Mai_Mauergedenkstaette_02.jpg',
    text: 'Treffen Mai Mauergedenkstätte'
  },
  {
    src: 'Treffen_Mai_Mauergedenkstaette_03.jpg',
    text: 'Treffen Mai Mauergedenkstätte'
  },
  {
    src: 'Treffen_Mai_Mauergedenkstaette_04.jpg',
    text: 'Treffen Mai Mauergedenkstätte'
  },
  { src: 'Treffen_Mai_Offene_Fragen.jpg', text: 'Treffen Mai Offene Fragen' },
  { src: 'Treffen_Mai_Plenum.jpg', text: 'Treffen Mai Plenum' },
  {
    src: 'Treffen_Mai_Versoehnungskapelle_03.jpg',
    text: 'Treffen Mai Versöhnungskapelle'
  },
  {
    src: 'Treffen_Sept_Beim_Vortrag_02.jpg',
    text: 'Treffen September beim Vortrag'
  },
  {
    src: 'Treffen_Sept_Beim_vortrag.jpg',
    text: 'Treffen September beim Vortrag'
  },
  {
    src: 'Treffen_Sept_Vortrag_ueber_Pater_Paolo.jpg',
    text: 'Treffen September Vortrag über Pater Paolo'
  },
  {
    src: 'Unsere_Gruppe_2018_Museum.jpg',
    text: 'Unsere Gruppe 2018 Museum Otto Weidt'
  },
  { src: 'Unsere_Gruppe_2018.jpg', text: 'Unsere Gruppe 2018' },
  // { src: 'Z8bgdqRSaAQ', text: '', type: 'youtube' },
  {
    src: 'Treffen_juli_In_der_bulgarisch_orthodoxen_Kirche.jpg',
    text: 'Unsere Gruppe'
  },
  {
    src: 'Treffen_Sept_Im_Bodemuseum.jpg',
    text: 'Treffen September Im Bodemuseum'
  },
  { src: 'Wiedersehen_Oktober_2018.jpg', text: 'Wiedersehen Oktober 2018' }
]

const INTERVAL = 3000

export default function Group() {
  return (
    <section id="group" className="group group--background">
      <h2 className="group-title">Unsere Gruppe</h2>
      <h4 className="group-subtitle">Projektgruppe Erinnerte Zukunft</h4>
      <CarouselImages
        slides={TEXTS}
        interval={INTERVAL}
        className="groupimages"
        slideRTL={false}
      />
    </section>
  )
}



/** WEBPACK FOOTER **
 ** ./src/components/group.js
 **/